import React, {useState,useEffect,useContext,useRef, lazy, Suspense} from "react";
import { useTranslate } from 'react-redux-multilingual';
import { CardPerso, AddItemToList, SelectConvertItemsList,ArticleBarSearch} from "@gull";
import axios from 'axios'
import swal from "sweetalert2"
import { IsAuthContext } from 'app/App';

const useLoadInit = (articleListInfo) => {
    const t = useTranslate();
    const [loadingZone,setLoadingZone] = useState(true)
    const [allZones,setAllZones] = useState([])

    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/zone/getall/"+articleListInfo.section_id
            ).then((response) => {
                setAllZones(response.data.datas)
                setLoadingZone(false)
            }).catch((error) => {
                if(error=='end_session') return;
                let messageError
                if(error.response==undefined){
                    messageError='unknowError'
                }
                else if(error.response.status==403){
                    messageError='forbiddenGeneral'
                }
                else {
                    messageError='unknowError'
                }
                
                swal.fire(t(messageError), "", "error");
                setLoadingZone(false)
            })
        })()
    }, [])

    const [loadingSearchItem,setLoadingSearchItem]=useState(false)
    const [listSearchItem,setListSearchItem]=useState([])
    const [datas,setDatas] = useState(listSearchItem)
    const searchInput = useRef('')

    const loadItems = async (inputValue) => {
        setLoadingSearchItem(true)
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/article/name/"+inputValue
        ).then((response) => {
            setLoadingSearchItem(false)
            setListSearchItem(response.data.datas)
            let ajour = response.data.datas.filter((value)=>value.name.replace(/\u00A0/g,' ').toLowerCase().includes(searchInput.current.value.replace(/\u00A0/g,' ').toLowerCase()))
            setDatas(ajour)
        }).catch((error) => {
            if(error=='end_session') return;
            setLoadingSearchItem(false)
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
    }
    
    return [allZones,loadingZone,loadingSearchItem,setLoadingSearchItem,loadItems,listSearchItem,datas,setDatas,searchInput]
}

const FormulaireAjoutArticleItemList = (props) => {
    const t = useTranslate();
    const [allZones,loadingZone,loadingSearchItem,setLoadingSearchItem,loadItems,listSearchItem,datas,setDatas,searchInput] = useLoadInit(props.articleListInfo)
    const [showAccordion,setShowAccordion]=useState(false) 
    const [zoneArticleListe,setZoneArticleListe] = useState('')

    const { authParam } = useContext(IsAuthContext);
    let actualShop = authParam.sections.find(value=>value.id==props.articleListInfo.section_id)

    useEffect(function () {
        if(allZones.length!=0){
             
            let zoneCom = false
            if (actualShop && actualShop.advanceparams?.hasOwnProperty('reference_default_zone')) { // Si il y à une zone par défaut pour la section on la prend
                if (actualShop.advanceparams?.reference_default_zone==null) zoneCom = ''
                else zoneCom = allZones.find(zone => zone.id == actualShop.advanceparams?.reference_default_zone)
            }
            else { // Sinon par défaut on renseigne la zone sur la zone commerciale sur magasin
                zoneCom = allZones.find(zone => zone.type == 'commerciale')
            }

            setZoneArticleListe(zoneCom.id)
        }
    }, [allZones])

    const [inputScan,setInputScan]=useState('')

    const handleSubmitArticleListe = async (obj,setValidButton,resetFiltreItemsToPromo,setShowModalAdd) =>{
        setValidButton(true)

        const response = await axios.post(process.env.REACT_APP_API_URL+"api/wms/article_list_detail", obj
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else {
                props.setReload(Date.now())
                if(resetFiltreItemsToPromo) resetFiltreItemsToPromo()
                setValidButton(false)
                if(setShowModalAdd) setShowModalAdd(false)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let messageError
            if(error.response==undefined){
                messageError='unknowError'
            }
            else if(error.response.status==403){
                messageError='forbiddenGeneral'
            }
            else {
                messageError='unknowError'
            }
            
            swal.fire(t(messageError), "", "error");
            setValidButton(false)
        })
    }

    const addNewItem = async (e,articleid,inputname,articleBar) =>{//selection l'article dans l'input data
        let article = (e) ? e.target.value : articleid
        let urlArticle = (e) ? "api/erp/article/reference/" : "api/erp/article/one/"
        
        setLoadingSearchItem(true)
        const response = await axios.get(process.env.REACT_APP_API_URL+urlArticle+article
        ).then((response) => {
            if(response.data.hasOwnProperty('valid') && !response.data.valid){
                swal.fire(t('articleNoReferenceFind'), "", "error");
            }else{        
                let obj ={
                    article_list: props.articleListeId,
                    articles: (e) ? [response.data.data.article.id] : [response.data.data.id],
                    quantity: [1],
                    zone: zoneArticleListe
                }

                handleSubmitArticleListe(obj,setLoadingSearchItem,false,false)
                setInputScan('')
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
    }

    return (
        <CardPerso header={<>
                <button
                    className="btn btn-sm btn-success"
                    onClick={()=>setShowAccordion(!showAccordion)}
                >
                    {t('addItemsMass')}
                </button>
            </>}>

            <div className="row">
                <div className="col-12 col-lg-4 form-group">
                    <label>{t('addItem')}</label>
                    <ArticleBarSearch 
                        loadingSearchItem={loadingSearchItem}
                        loadItems={loadItems}
                        listSearchItem={listSearchItem}
                        datas={datas}
                        setDatas={setDatas}
                        valueInput={inputScan}
                        setValueInput={setInputScan}
                        handleSubmit={addNewItem}
                        searchInput={searchInput}
                        noBlur={true}
                        icon='true'
                    />
                </div>
                <div className='col-12 col-md-6 col-lg-4 form-group position-relative'>
                    <label>{t('selectStorageDestination')}</label>
                    <select disabled={loadingZone} className='form-control' value={zoneArticleListe} onChange={(e)=>setZoneArticleListe(e.target.value)}>
                        <option value="">-- Select --</option>
                        {allZones.map(value=>{
                            return(
                                <option key={value.id} value={value.id}>{value.name}</option>
                            )
                        })}
                    </select>
                    {loadingZone ? <div className="spinner-border spinner-border-sm" style={{position:'absolute', top:'55%'}}></div> : false}
                </div>
                {props.convertIntoList &&
                    <div className="col-12 col-md-6 col-lg-4">
                        <SelectConvertItemsList
                            listeArticle={props.articleListInfo}
                            from='erp'
                        />
                    </div>
                }
            </div>

            {(showAccordion) &&
                <>
                    <hr />
                    <AddItemToList 
                        liaisons={props.liaisons}
                        customFields={props.customFields} 
                        setToast={props.setToast}
                        customInterface={props.customInterface}
                        setCustomInterface={props.setCustomInterface}
                        setReload={props.setReload}

                        setShowAccordion={setShowAccordion}
                        articleListInfo={props.articleListInfo}//Info sur la liste d'article
                        articleListeId={props.articleListeId}//Id de la liste d'article
                        tableName={"baseAddItemToItemList"+props.module}
                        from='itemList'
                        handleSubmitArticleListe={handleSubmitArticleListe}

                        zoneArticleListe={zoneArticleListe}
                    />
                </>
            }
            
        </CardPerso>
    );
}

export default FormulaireAjoutArticleItemList;


